import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchDiscountsApi } from 'api/discount'
import { Discount, DiscountSearchForm } from 'entities/discount'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { discountColumnInfoList, DiscountTableData } from './discount_table'
import { DisplaySetting, DisplaySettingModal, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditDiscountForm, NewDiscountForm } from './discount_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const DiscountsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<DiscountSearchForm>()
    const searchForm = useForm<DiscountSearchForm>(query)
    const api = useFetchDiscountsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<Discount>()
    const discountDisplaySetting = useDisplaySetting(discountColumnInfoList(searchForm), 'Discount')
    const displaySettings: DisplaySetting[] = [discountDisplaySetting]
    const [selectedDiscount, setSelectedDiscount] = useState<Discount>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof DiscountSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`discounts?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            <EditDiscountForm
                discount={selectedDiscount}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="割引"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewDiscountForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<DisplaySettingModal displaySettings={displaySettings} />}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={discountDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={discountDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((discount: Discount) => {
                                return (
                                    <CheckboxTableRow
                                        key={`discount-${discount.id}`}
                                        item={discount}
                                        multipleCheckForm={multipleCheckForm}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedDiscount(discount)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <DiscountTableData
                                            discount={discount}
                                            displaySetting={discountDisplaySetting}
                                        />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Discount"
            >
            </SelectionFixedFooter>
        </>
    )
}

export default withRouter(DiscountsPage)

